import React from 'react';
import { Link } from 'react-router-dom';
import { UserCircle, X, Zap } from 'lucide-react';

interface SignInPromptProps {
  onClose: () => void;
}

export const SignInPrompt: React.FC<SignInPromptProps> = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="min-h-screen px-4 text-center">
        {/* Backdrop */}
        <div 
          className="fixed inset-0 bg-black/50 backdrop-blur-sm" 
          onClick={onClose}
        />
        
        {/* Modal */}
        <div className="inline-block w-full max-w-md my-8 text-left align-middle transition-all transform">
          <div className="relative bg-white dark:bg-gray-800 rounded-xl shadow-2xl">
            {/* Close button */}
            <button
              onClick={onClose}
              className="absolute right-4 top-4 p-2 rounded-full text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
            >
              <X className="w-5 h-5" />
            </button>

            {/* Content */}
            <div className="p-6">
              <div className="text-center">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-100 dark:bg-blue-900/30 mb-4">
                  <UserCircle className="w-8 h-8 text-blue-600 dark:text-blue-400" />
                </div>
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-2">
                  Get More Free Searches
                </h2>
                <p className="text-gray-600 dark:text-gray-300 mb-4">
                  Create an account to unlock additional free searches and save your favorites
                </p>

                {/* Benefits */}
                <div className="bg-blue-50 dark:bg-blue-900/20 rounded-lg p-4 mb-6 text-left">
                  <div className="flex items-start gap-3">
                    <Zap className="w-5 h-5 text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5" />
                    <div>
                      <h3 className="font-medium text-blue-900 dark:text-blue-300">
                        Free Account Benefits
                      </h3>
                      <ul className="mt-2 text-sm text-blue-800 dark:text-blue-200 space-y-1">
                        <li>• Get additional free searches</li>
                        <li>• Save your favorite predictions</li>
                        <li>• Access your search history</li>
                      </ul>
                    </div>
                  </div>
                </div>

                {/* Action buttons */}
                <div className="space-y-3">
                  <Link
                    to="/signup"
                    onClick={onClose}
                    className="w-full inline-flex items-center justify-center px-4 py-2.5 rounded-lg bg-blue-600 text-white hover:bg-blue-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
                  >
                    Create Free Account
                  </Link>
                  <Link
                    to="/signin"
                    onClick={onClose}
                    className="w-full inline-flex items-center justify-center px-4 py-2.5 rounded-lg border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
                  >
                    Sign In
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};